const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 113 114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffffff;}")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Nuevos i\u0301conos 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.4,88.14H64.46c-.29,5.32-3.66,8.69-8.3,8.69s-8.06-3.37-8.35-8.69H42.54c.29,7.27,5.81,13.42,13.62,13.42s13.28-6.15,13.57-13.42H86.87C90.05,88.14,92,86.48,92,84c0-3.86-3.81-7.23-7.08-10.65-2.78-3-3.32-9.18-3.76-14.4-.49-14.06-4.35-23.39-14.26-26.81-1.22-5-5.22-8.93-10.69-8.93s-9.52,3.9-10.7,8.93c-10,3.42-13.81,12.75-14.3,26.81-.44,5.22-1,11.37-3.76,14.4-3.27,3.42-7.08,6.79-7.08,10.65C20.32,86.48,22.22,88.14,25.4,88.14Zm1.46-5.08v-.49c.54-1.32,3-3.81,5.08-6.1,3.12-3.42,4.05-9.28,4.59-17C37.07,44,41.71,38.58,48.35,36.77,49.37,36.53,50,36,50,35c.24-3.95,2.49-6.79,6.15-6.79S62,31.06,62.26,35c.05,1,.64,1.52,1.66,1.76C70.56,38.58,75.2,44,75.74,59.43c.54,7.76,1.46,13.62,4.59,17,2.1,2.29,4.54,4.78,5.08,6.1v.49Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.3e163f0a4855b300a30e3f3a654ebb43.svg";
export { ForwardRef as ReactComponent };